<template>
	<div id="new-meal">
      <form-meal editingMode="create"></form-meal>
    <br/>
	</div>
</template>

<script>
import api from "../../api"
import formMeal from './formMeal'
export default {
	name: "newMeal",
  components: {
    formMeal
  }
}
</script>

<style lang='css'>
#new-meal {
	color: #53574D
}
</style>


